import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sms-consent-checkbox',
  templateUrl: './sms-consent-checkbox.component.pug',
  styleUrls: ['./sms-consent-checkbox.component.scss'],
  standalone: false
})
export class SmsConsentCheckboxComponent {
  @Input() checked = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onCheckedChange(checked: boolean) {
    this.checked = checked;
    this.checkedChange.emit(checked);
  }

  onTextClick(event: MouseEvent) {
    if ((event.target as HTMLElement).closest('a')) return;
    this.onCheckedChange(!this.checked);
  }
}
